<template>
  <header class="site-header">
    <div class="header-bar">
      <router-link to="/" class="brand" aria-label="圣淘沙信息科技 首页">
        <div>圣淘沙信息科技</div>
      </router-link>

      <nav class="desktop-nav">
        <router-link to="/">首页</router-link>
        <router-link to="/about">关于</router-link>
        <router-link to="/services">服务</router-link>
        <router-link to="/bulletin-board">博客</router-link>
        <router-link to="/faq">常见问题</router-link>
      </nav>

      <a class="download-button" href="#download">
        下载APP
        <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
          <line x1="12" y1="18" x2="12.01" y2="18"/>
        </svg>
      </a>

      <button class="menu-button" :class="{ open: menuOpen }" @click="menuOpen = !menuOpen" aria-label="菜单">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 移动端下拉菜单 -->
    <transition name="slide">
      <nav v-if="menuOpen" class="mobile-nav">
        <router-link to="/" @click.native="menuOpen = false">首页</router-link>
        <router-link to="/about" @click.native="menuOpen = false">关于</router-link>
        <router-link to="/services" @click.native="menuOpen = false">服务</router-link>
        <router-link to="/bulletin-board" @click.native="menuOpen = false">博客</router-link>
        <router-link to="/faq" @click.native="menuOpen = false">常见问题</router-link>
        <a class="mobile-dl" href="#download" @click="menuOpen = false">
          下载APP
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="phone-icon-sm">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
            <line x1="12" y1="18" x2="12.01" y2="18"/>
          </svg>
        </a>
      </nav>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'GlobalHeader',
  data() {
    return {
      menuOpen: false
    }
  },
  watch: {
    '$route'() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
.site-header {
  position: relative;
  z-index: 20;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.header-bar {
  max-width: 1180px;
  min-height: 92px;
  margin: 0 auto;
  padding: 18px 28px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.brand {
  text-decoration: none;
  font-size: 22px;
  font-weight: 900;
  color: #1f2933;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 30px;
  font-size: 16px;
  font-weight: 700;
}

.desktop-nav a {
  color: #1f2933;
  text-decoration: none;
}

.desktop-nav a:hover,
.desktop-nav a.router-link-exact-active {
  color: #1b79a0;
}

.menu-button {
  display: none;
  width: 48px;
  height: 42px;
  border: 0;
  background: transparent;
  padding: 4px;
  cursor: pointer;
}

.menu-button span {
  display: block;
  height: 4px;
  margin: 7px 0;
  background: #227b91;
  border-radius: 4px;
  transition: transform 0.25s, opacity 0.25s;
}

.menu-button.open span:nth-child(1) {
  transform: translateY(11px) rotate(45deg);
}

.menu-button.open span:nth-child(2) {
  opacity: 0;
}

.menu-button.open span:nth-child(3) {
  transform: translateY(-11px) rotate(-45deg);
}

.download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 50px;
  padding: 0 22px;
  border-radius: 10px;
  background: #1765b2;
  color: #fff;
  text-decoration: none;
  font-weight: 800;
  font-size: 16px;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.12);
}

.download-button .phone-icon {
  width: 18px;
  height: 18px;
  margin-left: 8px;
  flex-shrink: 0;
}

/* 移动端菜单 */
.mobile-nav {
  display: none;
}

@media (max-width: 780px) {
  .header-bar {
    min-height: 78px;
    padding: 22px 56px 8px;
  }

  .brand {
    font-size: 18px;
  }

  .desktop-nav {
    display: none;
  }

  .download-button {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .mobile-nav {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-top: 1px solid #eee;
    padding: 16px 28px 24px;
  }

  .mobile-nav a {
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #1f2933;
    text-decoration: none;
    padding: 14px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-nav a.router-link-exact-active {
    color: #1b79a0;
  }

  .mobile-dl {
    display: inline-flex !important;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
    min-height: 44px;
    padding: 0 20px !important;
    border-radius: 8px;
    background: #1765b2;
    color: #fff !important;
    font-size: 16px !important;
    border-bottom: 0 !important;
    width: fit-content;
  }

  .phone-icon-sm {
    width: 16px;
    height: 16px;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

@media (max-width: 420px) {
  .header-bar {
    padding-left: 28px;
    padding-right: 28px;
  }

  .brand {
    font-size: 16px;
  }
}
</style>
